import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators, } from '@angular/forms';
import { ToolsService } from '@app/services/tools.service';
import { ConstantsService } from '@app/services/constants.service';
import { ToastService } from '@app/services/toast.service';
import { IToolTable } from '@app/interfaces/IToolTable';
import { Labels } from '@app/util/labels.util';
import { Messages } from '@app/util/messages.util';
import { ToolComponent } from '@app/modules/tools/components/tool/tool.component';
import { MatTableDataSource } from '@angular/material/table';
import { removeEmptyProps } from '@app/util/common-utils';
import { TourGuideService } from '@app/services/tour-guide.service';
import { TourGuideContent } from '@app/util/tour-guide-content.util';
import { EnumService } from '@app/services/enum.service';
import { Enums } from '@app/util/enums';

@Component({
  selector: 'app-add-tool',
  templateUrl: './add-tool.component.html',
  styleUrls: ['./add-tool.component.scss'],
})
export class AddToolComponent implements OnInit, OnChanges {

  /****************** Variable declaration ******************/
  selectedRowData: any;
  qualitygates: any = [];
  tourGuideIds = TourGuideContent
  qgdatasource: any = new MatTableDataSource<any>([]);
  saveIcon = Messages.saveIcon;
  cancelIcon = Messages.cancelIcon;
  isEditMode: boolean = false;
  dataSource: IToolTable[] = [];
  selectLicense: string[];
  selectFltLicense: string[];
  selectOperatingSystem: string[] = this.constantService.OS_NAME;
  toolDataCopy: any;
  showMissingFieldError: boolean = false;
  toolForm: FormGroup;
  toolName: '';
  toolVersion: '';
  toolType: '';
  toolOperatingSystem: '';
  availableCount: 0;
  disable = false;
  showConfig = false;
  showFloatInp = false;
  fltLicDetails: any;
  thresholdForm: any = FormGroup;
  flag: boolean = false;
  editLicType: string;
  editFltLicType: string;
  isLicensedSelected: boolean;
  displayedColumns: string[] = ['position', 'name', 'description', 'threshold', 'edit', 'delete',];

  /**
  * Pattern Validator which ensures that the entire string contains only
  * alphanumeric characters, underscores, and hyphens and has a
  * length between 1 and 100 characters.
  */
  public patternValidate = /^[a-zA-Z0-9_-]{1,100}$/;
  public ipAddrPattern = "^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$"

  /**Labels used in this component */
  toolsName: string = Labels.toolName;
  toolsVersion: string = Labels.toolVrsn;
  selectTypes: string = Labels.selectTypes;
  selectFltType: string = Labels.selectFlType;
  selectOs: string = Labels.selectOs;
  avlCount: string = Labels.avlCount;
  FltIpAddr: string = Labels.FltIpAddr;
  name: string = Labels.name;
  ipAddr: string = Labels.ipAddr;
  toolTypeLabel: string = Labels.toolType;
  fltLicName: string = Labels.fltLicName;
  minCount: string = Labels.minCnt;

  /****************** Input and Output decorators ******************/
  @Input() addtool: string;
  @Input() showModal: boolean;
  @Input() toolData: any;
  @Output() closeModal = new EventEmitter<void>();
  @Output() dataSaved: EventEmitter<void> = new EventEmitter<void>();
  @Output() dataUpdated: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Constructor
   * @param tool 
   * @param formBuilder 
   * @param constantService 
   * @param enumService 
   * @param ts 
   * @param toolsService 
   * @param tourService 
   */
  constructor(public tool: ToolComponent,
    private formBuilder: FormBuilder,
    private constantService: ConstantsService,
    private enumService: EnumService,
    public ts: ToastService,
    private toolsService: ToolsService,
    public tourService: TourGuideService) {
    this.formValidation();
  }

  /**ngOnInit */
  ngOnInit() {
    if (this.tourService.isStartTour) {
      return;
    }
    this.getAllFltLicDet();
    this.selectType();
    this.toolData;
    this.showFloatInp = false;
  }

  /**ngOnChanges */
  ngOnChanges(): void {
    this.toolData;
    this.toolForm.patchValue({ active: true })
    this.updateData();
    this.toolDataCopy = { ...this.toolData };
    this.disableField();
    if (this.addtool == 'edit') {
      this.qualityGatesData = { added: [], updated: [], deleted: [], };
    }
    else { this.qualityGatesData = [] }
  }

  /**
  * formValidation function is used to add the validators in the form
  */
  formValidation() {
    this.toolForm = this.formBuilder.group({
      tool: ['', [Validators.required, Validators.pattern(this.patternValidate)]],
      version: ['', Validators.required],
      type: ['', Validators.required],
      os: ['', Validators.required],
      available: ['', [Validators.required]],
      minCnt: ['', [Validators.required]],
      toolType: [''],
      ipAddr: [''],
      fltLicNm: [''],
      active: [true],
    }, { validator: this.minimumCountValidator });
  }

  /**
   * Disable the form fields
   */
  disableFormField() {
    this.toolForm.controls['minCnt'].disable();
    this.toolForm.controls['available'].disable();
    this.toolForm.controls['toolType'].disable();
    this.toolForm.controls['ipAddr'].disable();
    this.toolForm.controls['toolType'].markAsUntouched();
    this.toolForm.controls['ipAddr'].markAsUntouched();
    this.toolForm.get('ipAddr')?.setErrors(null);
    this.toolForm.get('toolType')?.setErrors(null);
    this.toolForm.get('minCnt')?.setErrors(null);
    this.toolForm.get('available')?.setErrors(null);
    this.toolForm.get('fltLicNm')?.setErrors(null);
  }

  /**
   * Enable the form fields
   */
  enableFormField() {
    this.toolForm.controls['toolType'].enable();
    this.toolForm.controls['ipAddr'].enable();
    this.toolForm.controls['minCnt'].enable();
    this.toolForm.controls['available'].enable();
  }

  /**
   * On click of select type
   * @param type 
   */
  onSelectType(type: any) {
    let disable = type.value === 'free';
    if (type.value == 'licensed') {
      this.showConfig = true;
      this.showFloatInp = false;
    } else {
      this.showConfig = false;
      // Reset the specific form controls
      this.toolForm.get('toolType')?.reset();
      this.toolForm.get('ipAddr')?.reset();
    }

    if (disable) {
      this.disableFormField();
    } else {
      this.enableFormField();
    }
  }

  /**toggleFloatInp */
  toggleFloatInp() {
    if (!this.showFloatInp) {
      this.toolForm.get('toolType')?.addValidators([Validators.required, Validators.minLength(1)]);
      this.toolForm.get('ipAddr')?.addValidators([Validators.required, Validators.pattern(this.ipAddrPattern)]);
    } else {
      this.clearValidators()
    }

    this.toolForm.get('ipAddr')?.updateValueAndValidity();
    this.toolForm.get('toolType')?.updateValueAndValidity();

    this.showFloatInp = !this.showFloatInp
  }

  /** clear validators for ipaddr and tootype */
  clearValidators() {
    this.toolForm.get('toolType')?.clearValidators();
    this.toolForm.get('ipAddr')?.clearValidators();
  }
  /**
   * Minimum count validation
   * @param control 
   * @returns 
   */
  minimumCountValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const available = control.get('available')?.value;
    const minCnt = control.get('minCnt')?.value;
    let minCountValidator = null
    let invalid = null
    if (available !== null && minCnt !== null && minCnt >= available) {
      minCountValidator = { minCountExceedsAvailable: true }
      invalid = { invalid: true };
    }
    else if (minCnt === null) {
      minCountValidator = { noVal: true };
      invalid = { invalid: true };
    }
    control.get('minCnt')?.setErrors(minCountValidator);
    control.setErrors(invalid);
    return null;
  }

  /** isTypeFree to check if the tool type is free or licensed */
  isTypeFree(): boolean {
    const selectedType = this.toolForm.get('type')?.value;
    return selectedType === 'free';
  }

  /**
   * @returns form field error validation and error messages.
   */
  getToolErrMsg() {
    if (this.toolForm.get('tool')?.hasError('required')) {
      return Messages.addTool.toolNmReq;
    }
    return this.toolForm.get('tool')?.hasError('pattern') ? Messages.addTool.toolPattern : '';
  }

  getVersionErrMsg() {
    return Messages.addTool.toolVer;
  }

  getOsErrMsg() {
    return Messages.addTool.toolOs;
  }

  getTypeErrMsg() {
    return Messages.addTool.toolType;
  }

  getAvailErrMsg() {
    if (this.toolForm.get('available')?.hasError('required')) {
      return Messages.addTool.toolCntReq;
    }
    return this.toolForm.get('available')?.hasError('pattern') ? Messages.addTool.toolCntPattern : '';
  }

  gettoolTypeErrMsg() {
    return Messages.addTool.toolTypeInput;
  }

  getIpAddrErrMsg() {
    if (this.toolForm.get('ipAddr')?.hasError('required')) {
      return Messages.addTool.ipAddr;
    }
    return this.toolForm.get('ipAddr')?.hasError('pattern') ? Messages.addTool.ipAddrPattern : '';
  }

  getminCntErrMsg() {
    if (this.toolForm.get('minCnt')?.hasError('minCountExceedsAvailable')) {
      return Messages.addTool.minCntAvail;
    }
    if (this.toolForm.get('minCnt')?.hasError('noVal')) {
      return Messages.addTool.minCnt;
    }
    return this.toolForm.get('minCnt')?.hasError('pattern') ? Messages.addTool.minCntPattern : '';
  }

  /**onCloseModal functionality */
  onCloseModal() {
    this.closeModal.emit();
    this.showMissingFieldError = false;
    this.toolForm.reset();
    this.showConfig = false;
    this.showFloatInp = !this.showFloatInp;
    this.tool.getToolDet();
  }

  /**Fail to save error */
  failToSave() {
    this.ts.showError(Messages.addTool.error, Messages.addTool.toolFail);
  }

  /**Fail to update error */
  failToUpdate() {
    this.ts.showError(Messages.addTool.error, Messages.addTool.toolUpdFail);
  }

  /**On click of save on submit function will be called and all input will be saved in toolform. */
  onSubmit() {
    this.showMissingFieldError = !this.toolForm.valid
    if (this.toolForm.valid) {
      if (this.isEditMode) {
      } else {
        const { active, tool, version, type, os, toolType, available, minCnt, fltLicNm } = this.toolForm.value;
        let toolData: any;
        const qualityGates = this.qualityGatesData;

        if (type === 'free') {
          toolData = {
            actvFlg: active,
            toolNm: tool,
            toolVer: version,
            osNm: os,
            licType: type,
            crtId: 0,
          };
          this.addToolApi(toolData, qualityGates);
        }
        else {
          const fltSrvId = this.getIdByFltLicNm(fltLicNm);

          toolData = {
            actvFlg: active,
            toolNm: tool,
            toolVer: version,
            availCnt: available,
            osNm: os,
            licType: type,
            minCnt: minCnt,
            fltId: fltSrvId,
            crtId: 0
          };
          this.addToolApi(toolData, qualityGates);
        }
        this.clearValidators();
        this.closeModal.emit();
        this.toolForm.reset();
      }
    }
    else {
      this.tourService.scrollToView('container')
    }
  }

  /**
   * update data function is used to edit the tool data
   */
  updateData() {
    if (this.toolData !== null) {
      this.isEditMode = true;
      this.qualitygates = this.toolData?.qualityGates || [];
      this.qgdatasource = new MatTableDataSource<any>(this.qualitygates);
      const fltSrvNm = this.getFltNmById(this.toolData?.fltSrvId);
      this.showFloatInp = false;
      this.toolForm.patchValue({
        tool: this.toolData?.toolNm || '',
        version: this.toolData?.version || '',
        type: this.toolData?.licType || this.toolForm.value.type || '',
        fltLicNm: fltSrvNm,
        os: this.toolData?.osNm || '',
        available: parseInt(this.toolData?.availCnt) || '',
        minCnt: parseInt(this.toolData?.minCnt) || '',
        active: this.toolData?.active || '',
      });

    } else {
      this.isEditMode = false;
      this.qgdatasource = new MatTableDataSource<any>([]);
    }
  }

  /**
   * Update method Compares between the original & edited values
   * and then update only the edited values 
   */
  update() {
    const { tool, version, type, os, available, toolType, minCnt, active, fltLicNm } =
      this.toolForm.value;
    const fltSrvId = this.getIdByFltLicNm(fltLicNm);
    let tool_data: { [key: string]: any } = {
      toolNm: this.toolDataCopy.toolNm !== tool ? tool : undefined,
      toolVer: this.toolDataCopy.version !== version ? version : undefined,
      availCnt: this.toolDataCopy.availCnt !== available ? available : undefined,
      active: this.toolDataCopy.active !== active ? active : undefined,
      osNm: this.toolDataCopy.osNm !== os ? os : undefined,
      licType: type === 'others' ? this.toolForm.get('toolType')?.value : type,
      fltSrvId: fltSrvId,
      minCnt: this.toolDataCopy.minCnt !== minCnt ? minCnt : undefined,
      qualityGates: this.toolDataCopy.qualitygates !== this.qualitygates ? this.qualityGatesData : undefined,
      updId: this.toolDataCopy.toolId,
    };

    const id = this.toolDataCopy.toolId
    tool_data = removeEmptyProps(tool_data)  //deleting the objects who don't have any values

    if (tool_data['licType'] == 'free') {
      tool_data['fltSrvId'] = null;
    }
    if (this.toolForm.valid) {
      this.updateToolData(tool_data, id);
      this.clearValidators()
      this.closeModal.emit();
      this.toolForm.reset();
    }
  }

  /**Disable the available count & minimum count field if the license type is "free" */
  disableField() {
    if (this.toolDataCopy && this.toolDataCopy.licType === 'free') {
      this.toolForm.get('available')?.disable();
      this.toolForm.get('minCnt')?.disable();
    } else {
      this.toolForm.get('available')?.enable();
      this.toolForm.get('minCnt')?.enable();
    }
  }

  /**
   * getQualityGatesData function is used to get the quality gates data.
   * @returns qualityGates
   */
  qualityGatesData: any;
  saved(event: any) {
    if (this.addtool == 'add' && !Array.isArray(this.qualityGatesData)) {
      this.qualityGatesData = [];
    }
    if (Array.isArray(event)) {
      event.map((el: any) => { delete el.position; delete el.uniqId; return el });
      this.qualityGatesData = event
      return
    }

    let tempObj = JSON.parse(JSON.stringify(event))
    for (let [key, value] of Object.entries(tempObj)) {
      if (key !== 'deleted') {
        tempObj[key] = tempObj[key].map((el: any) => {
          let { position, uniqId, ...remO } = el
          return remO
        })
      }
    }
    this.qualityGatesData = tempObj
  }

  /****************************API Calls *****************************/

  /**
   * Add a new floating license detail
   */
  saveFltLicDet(clickData: any) {
    clickData.preventDefault();
    const fltLicName = this.toolForm.get('toolType')?.value;
    const fltLicIp = this.toolForm.get('ipAddr')?.value;
    let data = { licSrvNm: fltLicName, ipAddr: fltLicIp }

    this.toolsService.addFltLicType(data).subscribe((resp: any) => {
      this.selectFltLicense.push(fltLicName);
      this.showFloatInp = false;
      // Reset the specific form controls
      this.toolForm.get('toolType')?.reset();
      this.toolForm.get('ipAddr')?.reset();
      this.getAllFltLicDet();
      this.ts.showSuccess(Messages.success, Messages.fltLicSrv.fltLicAdd);
      this.clearValidators();
    }), () => {
      this.ts.showError(Messages.error, Messages.fltLicSrv.fltLicAddErr);
      this.showFloatInp = false;
    }
  }

  /**
   * selectType fetchs all the lic enum types present in the database
  */
  selectType() {
    this.enumService.allValues(Enums.LIC_TYPE).subscribe((response: any) => {
      this.selectLicense = response?.data?.dbResp;
    });
  }

  /**
   * Add tool data api call for passing the data from toolform.
   * @param tool_data
  */
  addToolApi(tool_data: any, qualityGates: any) {
    tool_data.qualityGates = qualityGates;
    this.toolsService.postAddTool(tool_data).subscribe((resp: any) => {
      this.ts.showSuccess(Messages.addTool.success, Messages.addTool.toolAdd);
      this.dataSaved.emit(tool_data);
      this.tool.getToolDet();
    }, () => {
      this.failToSave();
    }
    );
  }

  /**Update tool data */
  private updateToolData(tool_data: any, id: number,) {
    this.toolsService.updateTool(id, tool_data).subscribe(() => {
      this.ts.showSuccess(Messages.addTool.success, Messages.addTool.toolUpdate);
      this.tool.getToolDet();
    }, () => {
      this.failToUpdate();
      this.tool.getToolDet();
    }
    );
  }

  /**
   * Get all floating license details
   */
  getAllFltLicDet() {
    this.toolsService.getAllFltLic().subscribe((resp: any) => {
      this.fltLicDetails = resp.data.dbResp;
      this.selectFltLicense = resp.data.dbResp.map((item: { fltLicSrvrNm: any; }) => item.fltLicSrvrNm);
    })
  }

  /**get id by floating lic name */
  getIdByFltLicNm(fltSrvNm: string) {
    const selectedFltDetail = this.fltLicDetails.find((fltDetail: { fltLicSrvrNm: string; }) => fltDetail.fltLicSrvrNm === fltSrvNm);
    return selectedFltDetail?.fltSrvId; // If no matching fltDetail found
  }

  /**get floating name by id */
  getFltNmById(id: any) {
    const selectedFltId = this.fltLicDetails?.find((fltDetail: { fltSrvId: number; }) => fltDetail.fltSrvId === id);
    if (selectedFltId) {
      return selectedFltId.fltLicSrvrNm;
    }
    return undefined; // If no matching fltDetail found
  }
}